module.exports = __webpack_public_path__ + "img/filters.59272fe0.png";